<template>
    <div class="editing-reservation-banner">
      <span class="icon-bell-gold"></span>
      <div class="editing-reservation-banner__wrapper">
        <p class="editing-reservation-banner__title">{{ ModifyReservationBookingWizardTitle }}</p>
        <p v-if="isRoomList" class="editing-reservation-banner__description">
          {{ ModifyReservationBookingWizardSubTitle }}
        </p>
        <modify-edit-discard-modal
          :text="ModifyReservationDiscardPopupMessageTitle"
          :button-label="ModifyReservationDiscardPopupCTALabel"
        >
          <div slot-scope="{ activate }" class="">
            <button
              @click="activate"
              @keydown.space.prevent="activate"
              class="editing-reservation-banner__button button--secondary black size-md outlined"
            >
            {{ ModifyReservationBookingWizardCTADiscardLabel }}
            </button>
            <!-- <button
              v-if="!detectRoomChanges"
              @click="discardEdits"
              @keydown.space.prevent="activate"
              class="editing-reservation-banner__button button--secondary black size-md outlined"
            >
            {{ ModifyReservationBookingWizardCTADiscardLabel }}
            </button> -->
          </div>
        </modify-edit-discard-modal>
      </div>
    </div>
</template>

<script>
  import modifyEditDiscardModal from '../modify-edit-discard-modal/modify-edit-discard-modal.vue';
  import { mapState, mapGetters } from "vuex";

  export default {
    name: 'modify-edit-banner',
    components: {
      modifyEditDiscardModal,
    },
    props: {
      isRoomList: {
        type: Boolean,
        required: false,
        default: false
      },
      isRoomOverview: {
        type: Boolean,
        required: false,
        default: false
      },
      isGuestOrPaymentInfo: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    inject: [
     'modifyDetailPage'
    ],
    data: () => ({
      detectRoomChanges: false
    }),
    computed: {
      ...mapState("cart", [
        "cart"
      ]),
      ...mapGetters("modifyReservation", [
        "storedModifyBookingPropData",
      ]),
      ModifyReservationBookingWizardTitle() {
        return this.storedModifyBookingPropData?.ModifyReservationBookingWizardTitle
          ? this.storedModifyBookingPropData.ModifyReservationBookingWizardTitle
          : "";
      },
      ModifyReservationBookingWizardSubTitle() {
        return this.storedModifyBookingPropData?.ModifyReservationBookingWizardSubTitle
          ? this.storedModifyBookingPropData.ModifyReservationBookingWizardSubTitle
          : "";
      },
      ModifyReservationBookingWizardCTADiscardLabel() {
        return this.storedModifyBookingPropData?.ModifyReservationBookingWizardCTADiscardLabel
          ? this.storedModifyBookingPropData.ModifyReservationBookingWizardCTADiscardLabel
          : "";
      },
      ModifyReservationDiscardPopupMessageTitle() {
        return this.storedModifyBookingPropData?.ModifyReservationDiscardPopupMessageTitle
          ? this.storedModifyBookingPropData.ModifyReservationDiscardPopupMessageTitle
          : "";
      },
      ModifyReservationDiscardPopupCTALabel() {
        return this.storedModifyBookingPropData?.ModifyReservationDiscardPopupCTALabel
          ? this.storedModifyBookingPropData.ModifyReservationDiscardPopupCTALabel
          : "";
      }
    },
    methods: {
      discardEdits() {
        window.location.href= this.modifyDetailPage
      }
    }
  }
</script>
